<template>
	<div>
		<div v-if="showType === 1" class="title1">
			<span>4. 六个月内租金收入预览</span>
			<el-button type="primary" @click="addDialogVisible = true" size="small">添加租金</el-button>
		</div>

		<div v-if="showType === 2">
			<div class="title2">
				<span>租金列表，默认显示所有租金收入</span>
			</div>
			<el-row :gutter="20">
				<el-col :span="8">
					<el-date-picker v-model="dateRange" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels style="width: 100%"
						@change="timeChange">
					</el-date-picker>
				</el-col>
				<el-col :span="4">
					<el-button type="primary" @click="getIncomeList" icon="el-icon-search">范围搜索</el-button>
				</el-col>
				<el-col :span="12" class="header-last">
					<el-button type="warning" @click="addDialogVisible = true">添加租金</el-button>
				</el-col>
			</el-row>
		</div>

		<el-table :data="showType === 2 ? incomeList : incomeInSix.list" style="width: 100%" border
			@sort-change="changeSort">
			<el-table-column type="index"></el-table-column>
			<el-table-column prop="received_date" label="收租日期" :formatter="formatDate" min-width="120"
				sortable="custom">
			</el-table-column>
			<el-table-column prop="received_amount" label="收租金额" min-width="100">
			</el-table-column>
			<el-table-column prop="note" label="备注" min-width="400">
			</el-table-column>
			<el-table-column label="操作" width="120" fixed="right">
				<template slot-scope="scope">
					<el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
						<el-button type="primary" icon="el-icon-edit" size="mini"
							@click="showEditDialog(scope.row)">
						</el-button>
					</el-tooltip>
					<el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="removeCheckById(scope.row.id)">
						</el-button>
					</el-tooltip>
				</template>
			</el-table-column>
		</el-table>

		<slot :total="showType === 2 ? incomeTotal : incomeInSix.total"
			:handleCurrentChange="handleCurrentChange" :handleSizeChange="handleSizeChange"
			:queryInfo="queryInfo"></slot>

		<el-dialog title="添加租金" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
			<el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
				<el-row>
					<el-col :span="11">
						<el-form-item label="收租日期" prop="received_date">
							<el-date-picker v-model="addForm.received_date" align="left" type="date"
								placeholder="选择日期" :picker-options="pickerOptions" format="MM-dd-yyyy"
								style="width: 100%;">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="收租金额" prop="received_amount">
							<el-input v-model="addForm.received_amount" style="width: 100%;"
								placeholder="输入数字，不要带符号！">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="备注" prop="note">
					<el-input type="textarea" placeholder="请输入内容" v-model="addForm.note" maxlength="150"
						show-word-limit resize="none" :autosize="{ minRows: 3 }" style="width: 90%;">
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addCheck">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改租金" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
			<el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
				<el-row>
					<el-col :span="11">
						<el-form-item label="收入日期" prop="received_date">
							<el-date-picker v-model="editForm.received_date" align="left" type="date"
								placeholder="选择日期" :picker-options="pickerOptions" format="MM-dd-yyyy"
								style="width: 100%;">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="收入金额" prop="received_amount">
							<el-input v-model="editForm.received_amount" style="width: 100%;"
								placeholder="输入数字，不要带符号！">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="备注" prop="note">
					<el-input type="textarea" placeholder="请输入内容" v-model="editForm.note" maxlength="150"
						show-word-limit resize="none" :autosize="{ minRows: 3 }" style="width: 90%;">
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="editCheck">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import {mapState} from 'vuex';
export default {
	name: 'CheckFunction',
	props: ['pid', 'showType', 'queryInfo', 'getIncomeList'],
	data() {
		const validateNumber = (rule, value, callback) => {
			if (isNaN(value)) {
				callback(new Error('请输入数值！'));
			} else {
				callback();
			}
		};
		return {
			dateRange: [],
			addDialogVisible: false,
			addForm: {
				received_date: '',
				received_amount: '',
				note: ''
			},
			addFormRules: {
				received_date: [
					{required: true, message: '时间必须输入！', trigger: 'blur'}
				],
				received_amount: [
					{required: true, message: '请输入金额！', trigger: 'blur'},
					{validator: validateNumber, trigger: 'blur'}
				]
			},
			pickerOptions: {
				shortcuts: [{
					text: '今天',
					onClick(picker) {
						const date = new Date();
						date.setHours(0, 0, 0, 0);
						picker.$emit('pick', date);
					}
				}, {
					text: '昨天',
					onClick(picker) {
						const date = new Date();
						date.setHours(0, 0, 0, 0);
						date.setTime(date.getTime() - 3600 * 1000 * 24);
						picker.$emit('pick', date);
					}
				}, {
					text: '一周前',
					onClick(picker) {
						const date = new Date();
						date.setHours(0, 0, 0, 0);
						date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', date);
					}
				}]
			},
			editDialogVisible: false,
			editForm: {},
			editFormRules: {
				received_date: [
					{required: true, message: '时间必须输入！', trigger: 'blur'}
				],
				received_amount: [
					{required: true, message: '请输入金额！', trigger: 'blur'},
					{validator: validateNumber, trigger: 'blur'}
				]
			}
		};
	},
	computed: {
		...mapState('income', ['incomeList', 'incomeTotal', 'incomeInSix']),
	},
	methods: {
		handleCurrentChange(newPage) {
			this.queryInfo.currentPage = newPage;
			this.getCheckList();
		},
		handleSizeChange(newSize) {
			this.queryInfo.pageSize = newSize;
			this.getIncomeList();
		},
		changeSort({order, prop}) {
			this.queryInfo.order = order;
			this.queryInfo.prop = prop;
			this.getIncomeList();
		},
		formatDate(r, c, v) {
			if (v) return this.$dayjs(v).format('MM-DD-YYYY');
			return v;
		},
		timeChange(value) {
			if (!value) {
				this.queryInfo.date_start = null;
				this.queryInfo.date_end = null;
				this.queryInfo.currentPage = 1;
				this.getIncomeList();
			} else {
				this.queryInfo.date_start = value[0];
				this.queryInfo.date_end = value[1];
			}
		},
		addDialogClosed() {
			this.$refs.addFormRef.resetFields();
		},
		addCheck() {
			this.$refs.addFormRef.validate(async valid => {
				if (!valid) return;
				const {data: res} = await this.$http.post(`properties/incomeinfo/${this.pid}`, this.addForm);
				if (res.meta.status !== 201) return this.$message.error('添加租金失败！');
				this.$message.success('添加租金成功！');
				this.addDialogVisible = false;
				this.getIncomeList();
			});
		},
		showEditDialog(currentIncome) {
			this.editForm = {...currentIncome};
			this.editDialogVisible = true;
		},
		editDialogClosed() {
			this.$refs.editFormRef.resetFields();
		},
		editCheck() {
			this.$refs.editFormRef.validate(async valid => {
				if (!valid) return;
				const {data: res} = await this.$http.put(`properties/incomeinfo/${this.editForm.id}`, this.editForm);
				if (res.meta.status !== 200) return this.$message.error('修改租金失败！');
				this.$message.success('修改租金成功！');
				this.editDialogVisible = false;
				this.getIncomeList();
			});
		},
		async removeCheckById(cid) {
			const confirmResult = await this.$confirm('此操作将永久删除该租金, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).catch(err => err);

			// 如果用户确认删除， 则返回值为字符串 confirm
			// 如果用户取消了删除，则返回值为字符串 cancel
			if (confirmResult !== 'confirm') {
				return this.$message.info('已取消删除！');
			}

			const {data: res} = await this.$http.delete(`properties/incomeinfo/${cid}`);
			if (res.meta.status !== 200) {
				return this.$message.error('租金删除失败!');
			}
			this.$message.success('租金已成功删除！');
			this.getIncomeList();
		}
	}
}
</script>

<style lang="less" scoped>
.title1 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 700;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.title2 {
	text-align: center;
	font-size: 16px;
	line-height: 24px;
	font-weight: 700;
	margin-bottom: 20px;
}
.el-col.header-last {
	text-align: right;
}
.el-table {
	margin-top: 20px;
}
</style>